import React from 'react';
import './FloatingTextBar.css';

const FloatingTextBar = () => {
    return (
        <div className="floating-text-bar" aria-hidden="true">
            <div className="floating-text-content">
                Motion Graphics   -   Creative Direction   -   Interactive Design   -   3D Modelling   -   Exhibition Design   -   Creative Coding   -   Game Development   -   Sound Design   -   VR Development   -   Graphic Design   -   Motion Graphics   -   Creative Direction   -   Interactive Design   -   3D Modelling   -   Exhibition Design   -   Creative Coding   -   Game Development   -   Sound Design   -   VR Development   -   Graphic Design   -  Electronics & IoT   -   Stable Diffusion   -   AI   -   Tour Visuals   -    Projection Mapping   -   Creative Coding   -   Game Development   -   Sound Design   -   VR Development   -   Graphic Design   -   Motion Graphics   -   Creative Direction   -   Interactive Design   -   3D Modelling   -   Exhibition Design   -   Creative Coding   -   Game Development   -   Sound Design   -   VR Development   -   Graphic Design   -
            </div>
        </div>
    );
};

export default FloatingTextBar; 